export function addToggleButtonEventListeners(cards, cardWidth) {
  window.dataLayer = window.dataLayer || [];
  cards.forEach((card) => {
    const h3Text = card.querySelector('h3').innerText;
    const toggleButton = card.querySelector('.show-read-more');

    if (!toggleButton) {
      return;
    }

    toggleButton.addEventListener('click', (event) => {
      const currentSlide = card.closest('.slick-slide');
      const slickTrack = card.closest('.slick-track');

      if (!currentSlide || !slickTrack) return;

      const nextSlide = currentSlide.nextElementSibling;
      const isOpen = card.classList.toggle('open');

      if (isOpen) {
        card.style.overflow = 'visible';
        event.target.innerHTML = '&mdash;';
      } else {
        event.target.innerHTML = '+';
        setTimeout(() => {
          card.style.overflow = 'hidden';
        }, 500);
      }

      if (nextSlide) {
        nextSlide.style.marginLeft = isOpen ? cardWidth + 'px' : '20px';
      }

      const currentTrackWidth = slickTrack.scrollWidth;
      if (isOpen) {
        slickTrack.style.width = `${currentTrackWidth + cardWidth + 1000}px`;

        window.dataLayer.push({
          event: 'hpCardOpened',
          eventLabel: h3Text,
        });
        
      } else {
        setTimeout(() => {
          slickTrack.style.width = `${currentTrackWidth - cardWidth - 1000}px`;
        }, 500);
      }      
    });
  });
}

export function escapeHTML(html) {
  const doc = new DOMParser().parseFromString(html, 'text/html');
  return doc.body.textContent || '';
}

export function aspectRatioClassPattern() {
  return [
    'landscape',
    'portrait',
    'square',
    'square',
    'portrait',
    'landscape',
    'square',
    'square'
  ];
} 

export function dataLayerEventExist(event, value) {
  if (!value) {
    return true;
  }

  window.dataLayer = window.dataLayer || [];

  const matchingEvents = window.dataLayer.filter((e) => e.event === event);
  const matchingValues = matchingEvents.filter((e) => e.eventLabel === value);

  return matchingValues.length > 0;
}
